import { faArrowRight, faImage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {  useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../firebase.init';
import Loading from '../../Shared/Loading';



const MyProfile = () => {

    const [profileImg, setProfileImg] = useState('');
    const { register, formState: { errors }, handleSubmit, reset } = useForm();
    const imgStoreKey = '1102b1b472176018cfdab59d9d885956';


    const [user, loading] = useAuthState(auth);

    if (loading) {
        return <Loading />
    }
    
    const onSubmitImage = data => {
        const imges = data.myphoto[0];
        const formData = new FormData();
        formData.append('image', imges);

        const url = `https://api.imgbb.com/1/upload?key=${imgStoreKey}`;
        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data?.success === true) {
                    setProfileImg(data?.data?.url);
                    toast.success('Profile Photo Added!!')
                }
            })
    }

    const onSubmitForm = data => {

        const newProfile = {
            title: data?.mytitle,
            description: data?.mydes,
            img: profileImg
        }

        const url = `https://stark-wildwood-35883.herokuapp.com/myself/${user?.email}`
        fetch(url, {
            method: "PUT",
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(newProfile)
        })
            .then(res => res.json())
            .then(data => {
                if (data?.modifiedCount > 0) {
                    toast.success('Profile Update Successfully!!!');
                    reset();
                }
            })
    }

    return (
        <div className='bg-slate-200 px-8 py-10 md:h-screen md:p-6 h-screen'>
            <div className='grid md:grid-cols-2 grid-cols-1  gap-6'>
                <div>
                    <form onSubmit={handleSubmit(onSubmitImage)}>
                        <div className="form-control w-full mb-2 border-2 p-4 bg-white  rounded-lg custom_shadow border-green-500 ">
                            <label className="label font-semibold  lg:text-lg md:text-medium">My Photo</label>
                            <input
                                type="file"
                                placeholder="Banner Photo"
                                className="input input-bordered w-full cursor-pointer   "
                                {...register("myphoto", {
                                    required: {
                                        value: true,
                                        message: " My Photo is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.myphoto?.type === 'required' && <span className="label-text-alt text-red-500 ">{errors.myphoto.message}</span>}
                            </label>
                            <button type='submit' className='btn bg-green-500 border-0 text-white'> Add Photo <FontAwesomeIcon className='ml-2' icon={faImage} /> </button>
                        </div>
                    </form>
                </div>
                <div>
                    <form onSubmit={handleSubmit(onSubmitForm)}>
                        <div className="form-control w-full mb-2 border-2 p-4 bg-white  rounded-lg custom_shadow border-green-500 ">
                            <h2 className='text-2xl font-bold text-green-500 text-center py-3'>Update My Profile</h2>

                            <label className="label font-semibold lg:text-lg md:text-medium ">My Title</label>
                            <input
                                type="text"
                                placeholder="My Title"
                                className="input input-bordered w-full  mb-[-10px] "
                                {...register("mytitle", {
                                    required: {
                                        value: true,
                                        message: "My Title is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.mytitle?.type === 'required' && <span className="label-text-alt text-red-500 mt-2 ">{errors.mytitle.message}</span>}
                            </label>

                            <label className="label font-semibold lg:text-lg md:text-medium">My Description</label>
                            <textarea
                                type="text"
                                placeholder="My Description"
                                style={{ resize: 'none' }}
                                className="textarea textarea-bordered  "
                                {...register("mydes", {
                                    required: {
                                        value: true,
                                        message: "My Description is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.mydes?.type === 'required' && <span className="label-text-alt text-red-500 mt-2 ">{errors.mydes.message}</span>}
                            </label>
                            <button type='submit' className='btn bg-green-500 border-0 text-white'> Update My Profile <FontAwesomeIcon className='ml-2' icon={faArrowRight} /> </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default MyProfile;